import type { StatusMeta } from '@/types/statusTag'

export type FormatState =
    'DRAFT' | 'REVIEW' | 'REVISION' | 'APPROVAL' | 'DENIAL' | 'PUBLISHED' | 'ARCHIVED'

export const NOT_EDITABLE_STATUSES_FORMAT: FormatState[] = ['REVIEW', 'DENIAL', 'ARCHIVED']

type FormatStateMeta = StatusMeta & { message?: string }

export const FORMAT_STATE_META: Record<string, FormatStateMeta> = {
    DRAFT: {
        severity: 'primary',
        icon: 'pi-pen-to-square',
        labelKey: 'ui.organizer.formats.status.draft',
    },
    REVIEW: {
        severity: 'info',
        icon: 'pi-list-check',
        labelKey: 'ui.organizer.formats.status.review',
        message: 'ui.organizer.formats.reviewMessage',
    },
    REVISION: {
        severity: 'warn',
        icon: 'pi-pen-to-square',
        labelKey: 'ui.organizer.formats.status.revision',
    },
    APPROVAL: {
        severity: 'success',
        icon: 'pi-check-circle',
        labelKey: 'ui.organizer.formats.status.approval',
    },
    DENIAL: { severity: 'danger', icon: 'pi-lock', labelKey: 'ui.organizer.formats.status.denial' },
    ARCHIVED: {
        severity: 'contrast',
        icon: 'pi-file',
        labelKey: 'ui.organizer.formats.status.archived',
    },
    PUBLISHED: {
        severity: 'success',
        icon: 'pi-check-circle',
        labelKey: 'ui.organizer.formats.status.published',
    },
    PUBLISHED_DRAFT: {
        severity: 'primary',
        icon: 'pi-pen-to-square',
        labelKey: 'ui.organizer.formats.draftLabel',
        message: 'ui.organizer.formats.draftMessage',
    },
}

export const resolveFormatStateKey = (state: FormatState, hasDraftVersion: boolean): string =>
    state === 'PUBLISHED' && hasDraftVersion ? 'PUBLISHED_DRAFT' : (state ?? 'DRAFT')

export const getFormatStateMeta = ({
    state,
    hasDraftVersion,
}: {
    state: FormatState
    hasDraftVersion: boolean
}): FormatStateMeta => FORMAT_STATE_META[resolveFormatStateKey(state, hasDraftVersion)]
